import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const PublicLayout = () => {
    return (
        <div className="flex flex-col min-h-screen bg-slate-50 text-slate-800 font-sans">
            <Navbar />

            {/* Main Content Area */}
            <main className="flex-grow flex flex-col w-full">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
};

export default PublicLayout;